import { Button }                   from "@/components/ui/button"
import { Field }                    from '@/components/ui/field';
import { Text }                     from '@chakra-ui/react';
import { Stack }                    from '@chakra-ui/react';
import { toaster }                  from '@/components/ui/toaster';
import { useForm }                  from 'react-hook-form';
import { useTranslation }           from 'react-i18next';
import useTranslations              from '@/hooks/useTranslations';
import { useSearchParams }          from "react-router-dom";
import { Link }                     from "react-router-dom";
import { PasswordInput }            from '@/components/ui/password-input';
import UserResetPasswordTokenModel  from '@/models/services/fondations/UserResetPasswordTokenModel';

interface IConfirmationResetPasswordFormProps {
	setPasswordHasBeenReseted: React.Dispatch<React.SetStateAction<boolean>>
}

interface FormValues {
	newPassword: string;
	confirmNewPassword: string;
}

const ConfirmationResetPasswordForm = (props: IConfirmationResetPasswordFormProps) => {

	const { setPasswordHasBeenReseted } = props;

	const [searchParams] = useSearchParams();
	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();

	const {
		handleSubmit,
		register,
		getValues,
		formState: { errors, isSubmitting },
	} = useForm<FormValues>();

	return (
		<form onSubmit={handleSubmit(async ({ newPassword }) => {
			try {
				const model = new UserResetPasswordTokenModel();
				await model.patch({
					plainPassword: newPassword,
				}, {
					params: { 't': searchParams.get('t') },
				});
				setPasswordHasBeenReseted(true);
				toaster.create({
					title: t('pages.security.passwordBox.modals.forms.messages.success'),
					type: 'success'
				})
			} catch (error) {
				toaster.create({
					title: t('pages.resetPassword.form.messages.error.title'),
					description: t('pages.resetPassword.form.messages.error.description'),
					type: 'error'
				})
				console.log(error);
			}
		})}>
			<Stack gap="20px" marginTop="20px">
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.passwordBox.modals.forms.new')}
						</Text>
					}
					invalid={!!errors.newPassword}
					required
				>
					<PasswordInput
						placeholder={t('pages.security.passwordBox.modals.forms.new')}
						{...register("newPassword", {
							pattern: {
								value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
								message: t('pages.security.passwordBox.modals.forms.messages.errors.pattern'),
							}
						})}
					/>
					{errors.newPassword?.type === 'pattern' && <Text color="red">{t('pages.security.passwordBox.modals.forms.alert')}</Text>}
				</Field>

				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.passwordBox.modals.forms.confirm')}
						</Text>
					}
					invalid={!!errors.confirmNewPassword}
					required
				>
					<PasswordInput
						placeholder={t('pages.security.passwordBox.modals.forms.confirm')}
						{...register("confirmNewPassword", {
							validate: value => {
								const { newPassword } = getValues();
								return newPassword === value;
							},
						})}
					/>
					{errors.confirmNewPassword?.type === 'validate' && <Text color="red">{t('pages.security.passwordBox.modals.forms.messages.errors.match')}</Text>}
				</Field>

				<Button 
					variant="solid" 
					type="submit" 
					width="100%"
					marginTop="30px"
					loading={isSubmitting}
				>
					{t('pages.security.passwordBox.modals.forms.actions.save')}
				</Button>

				<Link 
					to={getNavigationTranslation('login', 'path')}
					style={{ marginTop: "50px" }}
				>
					<Text 
						textDecoration="underline"
						fontWeight={600}
					>
						{t('pages.registration.form.login')}
					</Text>
				</Link>
			</Stack>
		</form>
	);
};

export default ConfirmationResetPasswordForm